import { PaymentMethodsCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { Component } from '../../../../constants/CallbackConstants';
import { doFireStatusUpdate } from '../../../../utils/CallbackUtils';
/**
 * Util to fire status update when fetch existing mop
 * @param selectedMop
 * @param deviceData
 */
export var fetchExistingMop = function fetchExistingMop(selectedMop, deviceData) {
  doFireStatusUpdate([{
    status: StatusTypes.SUCCESS,
    command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
    payload: {
      component: Component.EXECUTE_COMMAND_LOGIC,
      data: {
        mop: selectedMop,
        deviceData: deviceData
      }
    }
  }]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/helpers/fetchExistingMop.js
// module id = 4521
// module chunks = 11